import React, { PureComponent, Fragment } from 'react';
// Components
import Button from 'ui/button';
import ReactDropzone from 'react-dropzone';
import styles from './dropzone.scss';
import { Fade } from 'ui/transition';
import { Loader } from 'ui/loader';
import { ICON_ADD } from 'icons';

interface DropzoneProps {
  accept?: string;
  label?: string;
  header?: string;
  error?: string;
  className?: string;
  disabled?: boolean;
  uploading?: boolean;
  style?: React.CSSProperties;
  onDrop: (files: File[]) => void;
}
export default class Dropzone extends PureComponent<DropzoneProps> {
  static defaultProps = {
    label: 'Select file',
    header: 'Drop files'
  };

  state = {
    hover: false
  };

  render() {
    const {
      children,
      disabled,
      uploading,
      className,
      style,
      accept,
      label,
      header,
      error,
      onDrop
    } = this.props;
    const { hover } = this.state;
    let cl = styles.dropzone;
    if (className) cl += ' ' + className;

    return (
      <ReactDropzone
        accept={accept}
        disabled={disabled || uploading}
        style={style}
        rejectClassName={cl + ' ' + styles.reject}
        acceptClassName={cl + ' ' + styles.hover}
        onDrop={onDrop}
        className={cl}
      >
        {uploading && <Loader />}
        {!uploading && (
          <div className={styles.inner}>
            <div className={styles.header}>{header}</div>
            <Button flat={label} raised icon={ICON_ADD} big />
            <Fade in={!!error} className="text-error margin">
              {error}
            </Fade>
          </div>
        )}
      </ReactDropzone>
    );
  }
}
